import { render, staticRenderFns } from "./CrosssellProducts.vue?vue&type=template&id=f0e888d4&"
import script from "./CrosssellProducts.vue?vue&type=script&lang=ts&"
export * from "./CrosssellProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports